/* eslint-disable */
export const authEn = {
  'Sign In': 'Sign In',
  'Sign Up': 'Sign Up',
  'Your Name': 'Enter Your Name',
  'Login': 'Enter login',
  'Password': 'Enter Password',
  'Confirm Password': 'Confirm Password',
  'Sign In to': 'Sign In to',
  'Sign Up to': 'Sign Up to',
  'Go to Main page': 'Go to Main page'
};

export const authRu = {
  'Sign In': 'Войти',
  'Sign Up': 'Регистрация',
  'Your Name': 'Укажите ваше имя',
  'Login': 'Укажите лoгин',
  'Password': 'Введите пароль',
  'Confirm Password': 'Подтвердите пароль',
  'Sign In to': 'Войти в',
  'Sign Up to': 'Регистрация в',
  'Go to Main page': 'На главную страницу',
  'Required': 'Это поле обязательно',
};
/* eslint-disable */